import React from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { toast } from "react-toastify";

import ModalMoveAssets from "./ModalMoveAssets";
import FormHelper from "../form.js";
import { ButtonValidation } from "../../../../component/Button.js";
import SelectQuery from "../../../../component/SelectQuery.js";
import Request from "../../../../config/Request.js";
import Lib from "utils/Lib";

export default class ModalLocation extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      alias: "",
      name: "",
      description: "",
      contact: "",
      is_process: false,
      popDeleteOpened: false,
      site: props.data.site
    };
    this.modalAction = this.modalAction.bind(this);

    this.onRegister = this.onRegister.bind(this);
    this.onRegisterSuccess = this.onRegisterSuccess.bind(this);
    this.onRegisterFailed = this.onRegisterFailed.bind(this);

    this.onUpdate = this.onUpdate.bind(this);
    this.onUpdateSuccess = this.onUpdateSuccess.bind(this);
    this.onUpdateFailed = this.onUpdateFailed.bind(this);

    this._modalMoveAssets = { ref: null };

    this.is_lite = false
  }

  togglePopDelete = () => {
    this.setState({ popDeleteOpened: !this.state.popDeleteOpened });
  };

  modalAction() {
    const { mode } = this.props;

    if (!FormHelper.ValidateFormNew(this.state,undefined,this.is_lite)) return;

    let data = {
      alias: this.state.alias,
      name: this.state.name,
      description: this.state.description,
      contact: this.state.contact,
      site: this.state.site
    };

    if (mode === "modal_add") this.onRegister(data);
    else this.onUpdate(data);
  }

  // ==================== Register
  async onRegister(data) {
    let payload = {
      Name: data.name,
      Description: data.description,
      ContactAlias: data.contact,
      SiteAlias: data.site
    };
    if(this.is_lite){
      const contact = await Request(
        "get",
        "read-contact-autocomplete", 
        {},
        {search:""},
        [],
        ()=>null,
        ()=>null,
        undefined,
        null
      )
      if(contact === null){
        this.onRegisterFailed
      }
      payload.ContactAlias = contact.results[0].Alias
      }
    Request(
      "post",
      "register-location",
      { Authorization: "Bearer " + this.props.UserReducer.token },
      payload,
      [],
      this.onRegisterSuccess,
      this.onRegisterFailed
    );

    this.setState({ is_process: true });
  }

  onRegisterSuccess(response) {
    toast.success("Register location success");
    this.setState({ is_process: false });
    this.props.close();
    this.props.onSuccess();
  }

  onRegisterFailed(error) {
    this.setState({ is_process: false });
    this.props.onFailed(error);
  }

  // ==================== Update
  onUpdate(data) {
    this.setState({ is_process: true });

    let payload = {
      Name: data.name,
      Description: data.description,
      ContactAlias: data.contact,
      SiteAlias: data.site
    };

    Request(
      "put",
      "update-location",
      { Authorization: "Bearer " + this.props.UserReducer.token },
      payload,
      [data.alias],
      this.onUpdateSuccess,
      this.onUpdateFailed
    );
  }

  onUpdateSuccess(response) {
    toast.success("Update location success");
    this.setState({ is_process: false });
    this.props.close();
    this.props.onSuccess();
  }

  onUpdateFailed(error) {
    this.setState({ is_process: false });
    this.props.onFailed(error);
  }

  restore = () => {
    this.setState({ is_process: true }, this.doDelete);
  };

  delete = async () => {
    const res = await Lib.confirm({
      okText: "Yes",
      title: "Delete location",
      content: (
        <div className="row">
          <div className="col-md-12">
            Are you sure want to delete location&nbsp;
            <strong>{this.props.data.name}</strong> ?
          </div>
        </div>
      )
    });

    if (res)
      this.setState({ is_process: true }, async () => {
        const assets = await Request(
          "get",
          "improved-read-asset",
          {
            Authorization: "Bearer " + this.props.UserReducer.token
          },
          { use_pagination: false, location: this.props.data.alias },
          [],
          undefined,
          this.onUpdateFailed,
          undefined,
          null
        );

        if (Array.isArray(assets)) {
          if (!!assets.length)
            this._modalMoveAssets.ref.open(this.props.data, assets);
          else this.doDelete();
        }
      });
  };

  doDelete = () => {
    Request(
      "put",
      "delete-location",
      { Authorization: "Bearer " + this.props.UserReducer.token },
      { Deleted: !this.props.data.deleted },
      [this.props.data.alias],
      () => {
        Lib.responseMessage(
          "success",
          `Location ${this.props.data.deleted ? "restored" : "deleted"}.`
        );
        this.setState({ is_process: false });
        this.props.close();
        this.props.onSuccess();
      },
      this.onUpdateFailed
    );
  };

  componentWillReceiveProps(nextProps, nC) {
    let new_state = {};
    if (nextProps.mode === "modal_update") {
      new_state = {
        alias: nextProps.data.alias,
        name: nextProps.data.name,
        description: nextProps.data.description,
        contact: nextProps.data.contact.Alias,
        site: nextProps.data.site.Alias
      };
    } else {
      new_state = {
        alias: "",
        name: "",
        description: "",
        contact: "",
        site: ""
      };
      if (nextProps.isFromSite) {
        new_state.site = nextProps.data.site.Alias;
      }
    }
    this.setState(new_state);
  }

  render() {
    const { isModal, close, mode } = this.props;
    this.is_lite = this.props.UserReducer.props.is_lite
    return (
      <Modal isOpen={isModal} toggle={close}>
        <ModalHeader toggle={close}>
          {mode === "modal_add" ? "Add new" : "Update"} Location
        </ModalHeader>
        <ModalBody>
          <div className="row">
            <div className="form-group col-sm-12">
              <label className="required">Name</label>
              <input
                type="text"
                className="form-control"
                placeholder="Type Name"
                value={this.state.name}
                disabled={this.props.data.deleted}
                onChange={e => this.setState({ name: e.target.value })}
              />
            </div>
            <div className="form-group col-sm-12">
              <label className="required">Description</label>
              <textarea
                rows="5"
                className="form-control"
                placeholder="Enter Location Description"
                value={this.state.description}
                disabled={this.props.data.deleted}
                onChange={e => this.setState({ description: e.target.value })}
              />
            </div>
            {!this.is_lite &&( 
            <div className="form-group col-sm-12">
              <label className="required">Contact</label>
              <SelectQuery
                placeholder="Type Contact"
                value={this.state.contact}
                onChange={e => this.setState({ contact: e.value })}
                urlKey="read-contact-autocomplete"
                valKey="Alias"
                valLabel="Name"
                initOption={this.props.data.contact}
                isCreatable={false}
                UserReducer={this.props.UserReducer}
                disabled={this.props.data.deleted}
              />
            </div>
            )}
            <div className="form-group col-sm-12">
              <label className="required">Site</label>
              <SelectQuery
                placeholder="Type Site"
                value={this.state.site}
                onChange={e => this.setState({ site: e.value })}
                urlKey="read-site-autocomplete"
                valKey="Alias"
                valLabel="Name"
                isCreatable={false}
                initOption={this.props.data.site}
                disabled={this.props.isFromSite || this.props.data.deleted}
                UserReducer={this.props.UserReducer}
              />
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <ButtonValidation
            color="default"
            is_process={this.state.is_process}
            onClick={close}
          >
            Cancel
          </ButtonValidation>
          <ButtonValidation
            is_process={this.state.is_process}
            onClick={this.modalAction}
            disabled={this.props.data.deleted}
          >
            {mode === "modal_add" ? "Save" : "Update"}
          </ButtonValidation>
          {mode !== "modal_add" && (
            <ButtonValidation
              color={this.props.data.deleted ? "success" : "danger"}
              is_process={this.state.is_process}
              onClick={this.props.data.deleted ? this.restore : this.delete}
            >
              {this.props.data.deleted ? "Restore" : "Delete"}
            </ButtonValidation>
          )}
        </ModalFooter>
        <ModalMoveAssets
          onRef={n => (this._modalMoveAssets.ref = n)}
          onSuccess={this.doDelete}
          onClose={() =>
            this.state.is_process && this.setState({ is_process: false })
          }
          UserReducer={this.props.UserReducer}
        />
      </Modal>
    );
  }
}

ModalLocation.defaultProps = {is_lite : false}


// WEBPACK FOOTER //
// ./src/App/location/location/helper/component/Modal.js